function Mauritania({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1615)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#496E2D"/>
  <path d="M16 18.4851C13.3359 18.4851 11.1103 16.6127 10.5642 14.1124C10.4803 14.4967 10.4348 14.8953 10.4348 15.3049C10.4348 18.3786 12.9264 20.8701 16 20.8701C19.0736 20.8701 21.5652 18.3786 21.5652 15.3049C21.5652 14.8953 21.5197 14.4967 21.4358 14.1123C20.8898 16.6127 18.6641 18.4851 16 18.4851Z" fill="#FFDA44"/>
  <path d="M16 11.1309L16.518 12.7252H18.1944L16.8382 13.7105L17.3562 15.3048L16 14.3194L14.6438 15.3048L15.1619 13.7105L13.8057 12.7252H15.482L16 11.1309Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Mauritania;
